export const Routes = {
  index: "/",
  home: "/home",
  register: "/register",
  registerSpouse: "/register-spouse",
  login: "/login",
  resetPassword: "/reset-password",
  dashboard: "/dashboard",

  // not needed again
  // eventPlanner: "/event-planner",
  // yourWeddns: "/event-planner/weddns",
  // editAccessCard: "/edit-access-card",
  // test: "/test",

  //catering
  catering: "/catering",
  cateringCentre: "/catering/centre",

  // guest routes
  guests: "/guests",
  guestsTablePlan: "/guests/tableplan",
  guestsWellWishes: "/guests/wellwishes",
  guestsMessaging: "/guests/messaging",
  guestsPreference: "/guests/preference",
  guestsAccessCards: "/guests/accesscards",
  guestsDeleted: "/guests/deleted",

  // website routes
  website: "/website",
  preWedding: "/website/pre",
  dDay: "/website/dday",
  overview: "/website/overview",
  templates: "/website/templates",
  websiteDesign: "/website/design",
  editWebsite: "/website/edit",
  basicsEdit: "/website/edit/basics",
  loveStoryEdit: "/website/edit/love-story",
  asoEbiEdit: "/website/edit/aso-ebi",
  eventSchedule: "/website/edit/event-schedule",
  galleryEdit: "/website/edit/gallery",
  giftingEdit: "/website/edit/gifting",
  qAndAEdit: "/website/edit/q-and-a",
  weddingPartyEdit: "/website/edit/wedding-party",

  // settings routes
  settings: "/settings",
  CollaborationsSettings: "/settings/collaboration",
  ShareFeedbackSettings: "/settings/share-feedback",
  SubscriptionSettings: "/settings/subscription",
  notFound: "*",

  // messaging routes
  messaging: "/messaging",
  messagingTemplates: "/messaging/templates",
  messagingCreate: "/messaging/create",
  messagingSend: "/messaging/send",
  messagingDetails: "/messaging/:id",

  // notification routes
  notifications: "/notifications",

  // weddnpro subscription routes
  weddnProSubscription: "/weddnpro-subscription",

  // support routes
  faqs: "/faqs",
  support: "/support",
  eventSupport: "/wdn/:id/support",
  messages: "/messages",
  sendMessage: "/send-a-message",

  // event planner routes
  eventPlannerWedding: "/wdn/:id",
  eventPlannerWeddingList: "/weddn-list",

  eventPlannerCatering: "/wdn/:id/catering",
  eventPlannerCateringCentre: "/wdn/:id/catering/centre",

  eventPlannerWeddnProSubscription: "/wdn/:id/weddnpro-subscription",
  eventPlannerGuests: "/wdn/:id/guests",
  eventPlannerGuestsTablePlan: "/wdn/:id/guests/tableplan",
  eventPlannerGuestsWellWishes: "/wdn/:id/guests/wellwishes",
  eventPlannerGuestsMessaging: "/wdn/:id/guests/messaging",
  eventPlannerGuestsPreference: "/wdn/:id/guests/preference",
  eventPlannerGuestsAccessCards: "/wdn/:id/guests/accesscards",
  eventPlannerGuestsDeleted: "/wdn/:id/guests/deleted",

  eventPlannerWebsite: "/wdn/:id/website",
  eventPlannerPreWedding: "/wdn/:id/website/pre",
  eventPlannerDDay: "/wdn/:id/website/dday",
  eventPlannerOverview: "/wdn/:id/website/overview",
  eventPlannerTemplates: "/wdn/:id/website/templates",
  eventPlannerWebsiteDesign: "/wdn/:id/website/design",
  eventPlannerEditWebsite: "/wdn/:id/website/edit",
  eventPlannerBasicsEdit: "/wdn/:id/website/edit/basics",
  eventPlannerLoveStoryEdit: "/wdn/:id/website/edit/love-story",
  eventPlannerAsoEbiEdit: "/wdn/:id/website/edit/aso-ebi",
  eventPlannerEventSchedule: "/wdn/:id/website/edit/event-schedule",
  eventPlannerGalleryEdit: "/wdn/:id/website/edit/gallery",
  eventPlannerGiftingEdit: "/wdn/:id/website/edit/gifting",
  eventPlannerQAndAEdit: "/wdn/:id/website/edit/q-and-a",
  eventPlannerWeddingPartyEdit: "/wdn/:id/website/edit/wedding-party",

  eventPlannerSettings: "/wdn/:id/settings",
  eventPlannerCollaborationsSettings: "/wdn/:id/settings/collaboration",
  eventPlannerShareFeedbackSettings: "/wdn/:id/settings/share-feedback",
  eventPlannerSubscriptionSettings: "/wdn/:id/settings/subscription",

  // thingsToDo: "/things-to-do",
  // sendInvites: "/send-invites",
  // setUpWebsite: "/setup-website",
  // accessCards: "/access-cards",
  // lovewall: "/lovewall",
  // weddingParty: "/wedding-party",
  // asoEbi: "/aso-ebi",
};
